import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectScheduledTasksListItems, selectScheduledTasksQueryItems } from '../../../../../redux/scheduled-tasks/selector';
import { selectListItems } from '../../../../../redux/library/selector';
import { scheduledTasks } from '../../../../../redux/scheduled-tasks/action';
import { deepCopy } from '../../../../../common/services/common.service';
import PageLoader from '../../../../../components/PageLoader';
import Popup from '../../../../../common/components/popup';
import ModalTasksComponent from '../components/sheduled-modal.component';
import SheduledComponent from '../components/sheduled.component';
import moment from 'moment';
import { accountTypes } from '../../../../../redux/account-types/action';
import { scheduledTasksConfigurations } from '../../../../../redux/sheduled-tasks-configuration/action';
import { selectScheduledTasksConfigurationsListItems } from '../../../../../redux/sheduled-tasks-configuration/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { ListCriteria } from '../../../../types/list-criteria';

const ManagementScheduledTask = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [columnDefs, setColumnDefs] = useState({});
    const [selectEventTasks, setSelectEventTasks] = useState<any>([])
    const [addItem, setAddItem] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const queryItems = useSelector(selectScheduledTasksQueryItems)
    const [selectedSheduledTasksValues, setSelectedSheduledTasksValues] = useState([]);
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const libraryData = useSelector(selectListItems)
    const listItems = useSelector(selectScheduledTasksListItems)
    const configurationItems = useSelector(selectScheduledTasksConfigurationsListItems)
    const TypeData = libraryData?.result?.Type
    const [accountsList, setAccountsList] = useState<any>([])
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
    const accountItems = useSelector(selectAccountsListItems)
    const accountTypeItems = useSelector(selectAccountTypesListItems)

    const [
        selectedSheduledTasks,
        setSelectedSheduledTasks
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])


    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }

    const fetchQueryById = () => {
        dispatch(scheduledTasks.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/scheduled-tasks/fetch-detail`, entity: 'scheduledTasks', jsonData: {
                Context: {},
                Records: [
                    {
                        "ScheduledTaskId": parmas?.id,
                        "TenantId": 0
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedSheduledTasks({ ...selectedSheduledTasks, [field]: event })
        setSelectEventTasks({ ...selectEventTasks, [field]: event })
    }

    // media handle form change
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }

    const mapSelectedItem = (item: any) => {
        if (!item) return {};
        return {
            Name: item.Name,
            TimeInterval: item.TimeInterval,
            ScheduledTaskId: item.ScheduledTaskId,
            IsEnabled: item.Enabled ?? item.IsEnabled,
            EndDateUtc: item.EndDateUtc,
            StartDateUtc: item.StartDateUtc,
            StopOnError: item.StopOnError,
            Command: item?.ScheduleCommands?.[0]?.Command,
            ScheduleCommandTypeId: item?.ScheduleCommands?.[0]?.ScheduleCommandTypeId,
            Instruction: item?.ScheduleCommands?.[0]?.Instruction,
            DisplayOrder: item?.ScheduleCommands?.[0]?.DisplayOrder,
        };
    };

    useEffect(
        () => {
            createColumnDefs()

            dispatch(scheduledTasks.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/platform-scheduled-tasks/list`,
                entity: 'scheduledTasks',
                jsonData: {}
            }))

                .then(() => {
                    dispatch(scheduledTasksConfigurations.list({
                        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations/list`,
                        entity: 'scheduledTasksConfigurations',
                        jsonData: {

                        }
                    }))
                })

                .then(() => {
                    dispatch(accounts.list({
                        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
                        entity: 'accounts',
                        jsonData: {

                        }
                    }))
                })

                .then(() => {
                    if (parmas?.id > 0) {
                        fetchQueryById()

                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )


    useEffect(() => {
        if (isQuery && queryItems?.result?.items?.length > 0) {
            // main record - for Basic Info
            const mainRecord: any = queryItems?.result?.items?.[0];

            // set basic info correctly
            setSelectedSheduledTasks({
                Id: mainRecord?.Id,
                IsActive: mainRecord?.IsActive,
                IsEnable: mainRecord?.IsEnable,
                Name: mainRecord?.Name,
                Description: mainRecord?.Description,
                Remarks: mainRecord?.Remarks,
                ScheduledTaskId: mainRecord?.ScheduledTaskId,

                OwnerLevel: mainRecord?.OwnerLevel,
                OwnerLevelId: mainRecord?.OwnerLevelId,
                OwnerTypeId: mainRecord?.OwnerTypeId,
                OwnerType: mainRecord?.OwnerType,
                OwnerAccountId: mainRecord?.OwnerAccountId,
                OwnerAccountName: mainRecord?.OwnerAccountName,

                TimeInterval: mainRecord?.Tasks?.[0]?.EntityInfo?.TimeInterval,
                StartDateUtc: mainRecord?.Tasks?.[0]?.EntityInfo?.StartDateUtc,
                EndDateUtc: mainRecord?.Tasks?.[0]?.EntityInfo?.EndDateUtc,
            });


            //  task mapping
            const oneProgramItemsData: any =
                mainRecord?.Tasks?.map((task: any) => {
                    return {
                        Id: task?.Id,
                        Name: task?.EntityInfo?.Name,
                        TimeInterval: task?.EntityInfo?.TimeInterval,
                        ScheduledTaskId: task?.EntityInfo?.ScheduledTaskId,

                        //  always pick from task, fallback to entity or ScheduledTaskId
                        PlatformScheduledTaskId:
                            task?.EntityInfo?.PlatformScheduledTaskId,
                        ScheduleTaskConfigurationId: task?.EntityInfo?.ScheduleTaskConfigurationId,

                        IsEnabled: task?.EntityInfo?.IsEnabled,
                        EndDateUtc: task?.EntityInfo?.EndDateUtc,
                        StartDateUtc: task?.EntityInfo?.StartDateUtc,
                        StopOnError: task?.EntityInfo?.StopOnError,
                        LastStartUtc: task?.EntityInfo?.LastStartUtc,
                        LastEndUtc: task?.EntityInfo?.LastEndUtc,
                        LastSuccessUtc: task?.EntityInfo?.LastSuccessUtc,
                        Command:
                            task?.EntityInfo?.ScheduleCommands?.[0]?.Command,

                        ScheduleCommandTypeId:
                            task?.EntityInfo?.ScheduleCommands?.[0]?.ScheduleCommandTypeId,
                        Instruction:
                            task?.EntityInfo?.ScheduleCommands?.[0]?.Instruction,
                        DisplayOrder:
                            task?.EntityInfo?.ScheduleCommands?.[0]?.DisplayOrder,
                    };
                }) || [];

            setSelectedSheduledTasksValues(oneProgramItemsData);
        }
    }, [isQuery, queryItems]);


    useEffect(() => {
        if (selectEventTasks?.PlatformScheduledTaskId) {
            const selectedPlatform = listItems?.result?.items?.find(
                (p: any) => p.Id === selectEventTasks.PlatformScheduledTaskId
            );

            if (selectedPlatform) {
                setSelectEventTasks((prev: any) => ({
                    ...prev,
                    PlatformScheduledTaskId: selectedPlatform.Id,
                    ...mapSelectedItem(selectedPlatform)
                }));
            }
        }
    }, [selectEventTasks?.PlatformScheduledTaskId, listItems]);


    useEffect(() => {
        if (selectEventTasks?.ScheduleTaskConfigurationId) {
            const selectedConfiguration = configurationItems?.result?.items?.find(
                (p: any) => p.Id === selectEventTasks.ScheduleTaskConfigurationId
            );

            if (selectedConfiguration) {
                setSelectEventTasks((prev: any) => ({
                    ...prev,
                    ...mapSelectedItem(selectedConfiguration),
                }));
            }
        }
    }, [selectEventTasks?.ScheduleTaskConfigurationId, configurationItems]);



    const back = () => {
        navigate('/management/system/scheduled-tasks')
    }



    //Save the modal data function
    const handleSaveItem = async (data: any) => {
        const newItem = {
            Id: data?.Id,
            TabelId: Date.now(),
            Name: data?.Name,
            TimeInterval: data?.TimeInterval,
            ScheduledTaskId: data?.ScheduledTaskId,
            PlatformScheduledTaskId: data?.PlatformScheduledTaskId,
            ScheduleTaskConfigurationId: data?.ScheduleTaskConfigurationId,

            IsEnabled: data?.IsEnabled,
            EndDateUtc: data?.EndDateUtc,
            StartDateUtc: data?.StartDateUtc,
            StopOnError: data?.StopOnError || false,
            LastStartUtc: moment.utc(),
            LastEndUtc: moment.utc(),
            LastSuccessUtc: moment.utc(),
            Command: data?.Command,
            ScheduleCommandTypeId: data?.ScheduleCommandTypeId,
            Instruction: data?.Instruction,
            DisplayOrder: data?.DisplayOrder,
        };

        setSelectedSheduledTasksValues((prevState: any) => {
            const exists = prevState.some(
                (item: any) => item.Id === newItem.Id || item.TabelId === newItem.TabelId
            );
            return exists
                ? prevState.map((item: any) =>
                    item.Id === newItem.Id || item.TabelId === newItem.TabelId ? newItem : item
                )
                : [...prevState, newItem];
        });

        closeModal();
    };


    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Event Tickets</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name' },


        ]);
    }

    useEffect(() => {
        setAssociatedAccountTypeId(selectedSheduledTasks?.OwnerTypeId);
        setOwnerLevelId(selectedSheduledTasks?.OwnerLevelId);
    }, [selectedSheduledTasks]);

    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text === accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);




    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerLevelId]);

    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    //Add the data in the Table Function
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    //Table Edit Function
    const handleEdit = (itemData: any) => {
        setAddItem({
            id: itemData.id
        })
        setSelectEventTasks(itemData)

    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setSelectedSheduledTasksValues((prevState: any) =>
            prevState.filter((item: any) => item?.Id !== data?.Id)
        );

    };

    //Modal Close Function
    const closeModal = () => {
        setAddItem(undefined)
        setSelectEventTasks('')
    }

    // Modal Function
    const NewItemPopup = ({ handleSaveItem }: any) => {
        const [localItems, setLocalItems] = useState(deepCopy(selectEventTasks));
        const handleLocalFormChange = (value: any, field: any) => {
            if (field === "PlatformScheduledTaskId") {
                // find selected platform by Id
                const selectedPlatform = listItems?.result?.items?.find(
                    (p: any) => p.Id === Number(value)
                );

                if (selectedPlatform) {
                    setLocalItems((prev: any) => ({
                        ...prev,
                        PlatformScheduledTaskId: selectedPlatform.Id,
                        ...mapSelectedItem(selectedPlatform)
                    }));
                    return;
                }
            }
            if (field === "ScheduleTaskConfigurationId") {
                const selectedConfiguration = configurationItems?.result?.items?.find(
                    (p: any) => p.Id === Number(value)
                );

                if (selectedConfiguration) {
                    setLocalItems((prev: any) => ({
                        ...prev,
                        ScheduleTaskConfigurationId: selectedConfiguration.Id,
                        ...mapSelectedItem(selectedConfiguration),
                    }));
                    return;
                }
            }

            // default fallback for other fields
            setLocalItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };

        const handleItemSubmit = () => {
            setLocalItems(localItems);
            handleSaveItem(localItems)
        };

        return (
            <>
                <Popup onClose={closeModal}>
                    <ModalTasksComponent
                        Close={closeModal}
                        platForms={listItems?.result?.items}
                        handleItemSubmit={handleItemSubmit}
                        selectEventTasks={localItems}
                        onInnerBasicFormChange={handleLocalFormChange}
                        ScheduledTaskType={libraryData?.result?.ScheduledTaskType}
                        configurationItem={configurationItems?.result?.items}
                        sheduledType={libraryData?.result?.ScheduleCommandType}

                    />

                </Popup>
            </>
        )
    }
    // Submit the events Function
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )
        const EventTicketsItemsData: any = selectedSheduledTasksValues?.map((item: any) => {
            const itemData = {
                Id: item?.Id || 0,
                Name: item?.Name,
                TimeInterval: Number(item?.TimeInterval),

                ScheduledTaskId: item?.ScheduledTaskId,
                PlatformScheduledTaskId: item?.PlatformScheduledTaskId,

                //  include these from modal / selection
                ScheduleTaskConfigurationId: item?.ScheduleTaskConfigurationId || 0,
                ScheduledTaskType: item?.ScheduledTaskType || "",

                IsEnabled: item?.IsEnabled,
                EndDateUtc: item?.EndDateUtc,
                StartDateUtc: item?.StartDateUtc,
                StopOnError: item?.StopOnError || false,
                LastStartUtc: moment.utc(),
                LastEndUtc: moment.utc(),
                LastSuccessUtc: moment.utc(),
                ScheduleCommands: [
                    {
                        Command: item?.Command,
                        ScheduleCommandTypeId: Number(item?.ScheduleCommandTypeId),
                        Instruction: item?.Instruction,
                        DisplayOrder: Number(item?.DisplayOrder),
                    }
                ],
            }
            return itemData;
        });


        const eventData = {
            Id: selectedSheduledTasks?.Id || 0,
            ScheduledTaskId: selectedSheduledTasks?.ScheduledTaskId || 0,
            IsActive: selectedSheduledTasks?.IsActive || false,
            IsEnable: selectedSheduledTasks?.IsEnable || false,
            Name: selectedSheduledTasks?.Name,
            Description: selectedSheduledTasks?.Description,
            Remarks: selectedSheduledTasks?.Remarks,


            OwnerType: selectedSheduledTasks?.OwnerType || "",
            OwnerLevelId: selectedSheduledTasks?.OwnerLevelId || 0,
            OwnerTypeId: selectedSheduledTasks?.OwnerTypeId || 0,
            OwnerAccountId: selectedSheduledTasks?.OwnerAccountId || 0,
            OwnerLevel: selectedSheduledTasks?.OwnerLevel || "",
            OwnerAccountName: selectedSheduledTasks?.OwnerAccountName || "",


            Tasks: EventTicketsItemsData,
        }


        if (parmas?.id > 0) {
            await dispatch(scheduledTasks.resetAction({ actionType: 'update' }))
            await dispatch(scheduledTasks.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/scheduled-tasks`, entity: 'scheduledTasks', jsonData: {
                    "Context": {},
                    "Records": [
                        eventData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(scheduledTasks.resetAction({ actionType: 'create' }))
            await dispatch(scheduledTasks.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/scheduled-tasks`, entity: 'scheduledTasks', jsonData: {
                    "Context": {},
                    "Records": [
                        eventData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }

    useEffect(() => {
        dispatch(accounts.resetAction({ actionType: 'list' }))
        setAccountsList([])
    }, []);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);

    return (
        <>

            {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
            {isLoading ? <PageLoader /> :


                <SheduledComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedSheduledTasks={selectedSheduledTasks}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    selectedSheduledTasksValues={selectedSheduledTasksValues}
                    PolicyOwnerType={libraryData?.result?.PolicyOwnerType}
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    accountsList={accountsList}
                    isLoading={isLoading}


                />
            }

        </>
    )


}

export default ManagementScheduledTask;
